<template>
  <at-modal
    v-model="showMe"
    :showFooter="false"
    title="О проекте"
    :styles="{ top: '50px !important', width: '100vw' }"
  >
    <span class="at-modal__back" @click="goBack"
      ><i class="icon icon-chevron-left"></i
    ></span>
    <div class="maindiv">
      <div>
        <p>
          <b>Сетевой электронный словарь вятских говоров</b> (далее – Словарь)
          создан на основе <b>Тематического словаря вятских говоров</b> / отв.
          ред. З.В. Сметанина – Киров: Изд.-во «Радуга-ПРЕСС», 2013. – 311 с.:
          илл.
        </p>
        <p>
          Лексика из данного источника представлена на сайте по следующим
          основным разделам: «Природа», «Человек», «Крестьянский быт»,
          «Крестьянский труд», «Отдых», каждый раздел включает в себя несколько
          тематических групп.
        </p>
        <p>Поисковая строка сайта предлагает две возможности:</p>
        <ol>
          <li>
            набрать интересующее Вас диалектное слово (для этого все слова
            расположены в алфавитном порядке);
          </li>
          <li>
            найти слово по его значению, например, мы хотим выявить, каким
            словом в вятских говорах называют здорового, крепкого человека,
            набираем основу слов здоровый или крепкий без окончания и получаем
            ряд слов с одинаковым лексическим значением из тематического раздела
            «Человек».
          </li>
        </ol>
        <p>
          Словарь построен в виде геоинформационной системы (более подробные
          рекомендации по использованию ресурса см. в разделе
          <router-link to="help"><b>Инструкция</b></router-link
          >).
        </p>
        <p>
          Отбор лексики для Словаря осуществлялся в соответствии со следующими
          принципами: распространённость слова, отражение своеобразия региона.
        </p>
        <p>По характеру материала словарь является областным, диалектным;</p>
        <p>по назначению и аспекту системности — толковым и идеографическим;</p>
        <p>по целям применения — учебным.</p>
        <p>
          В словаре не ставилась цель представить полные ареальные
          характеристики слов и лексикографические источники, в которых
          зафиксировано то или иное слово. Карта отображает примеры наиболее
          частого употребления диалектных слов по районам. Это означает, что те
          или иные слова могли употребляться и в других районах Кировской
          области, но встречаются там реже.
        </p>
        <p>
          Словарь может служить как справочным, так и учебным пособием для школ,
          гимназий, лицеев, колледжей и вузов. Лексические и фразеологические
          материалы словаря дают достаточно яркую картину вятской деревни,
          крестьянского труда и быта, духовной жизни. Он позволяет сформировать
          у молодого поколения региона представление о словотворческом
          потенциале народа, богатстве народной речи.
        </p>
        <p style="text-align: left">
          Составители <b>Тематического словаря вятских говоров</b>:
          Г.А.&nbsp;Горюнова, В.В.&nbsp;Подрушняк, 3.В.&nbsp;Сметанина,
          А.Д.&nbsp;Степанова, М.А.&nbsp;Суворова, О.Н.&nbsp;Федянина
        </p>
        <p style="text-align: left">
          Разработчики <b>Сетевого электронного словаря вятских говоров</b>:
          Р.В.&nbsp;Марков, Д.В.&nbsp;Чупраков, А.О.&nbsp;Кайсин
        </p>
      </div>
    </div>
  </at-modal>
</template>

<script>
export default {
  data: () => ({
    showMe: true,
  }),
  watch: {
    showMe() {
      if (!this.showMe) this.$router.push({ path: "/" });
    },
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped>
img {
  width: 30%;
}

p,
li {
  text-align: justify;
  font-size: 154% !important;
  font-family: "Century Gothic", sans-serif;
  margin: 6px;
}

p b {
  font-family: var(--bs-font-sans-serif);
}

p:first-child:first-letter {
  font-family: "Izhitsa Cyrillic", sans-serif;
  color: rgb(255, 0, 0);
  font-size: 60px;
  line-height: 60px;
  vertical-align: top;
  display: inline-block;
  float: left;
  margin: 0 10px 0 0;
}

.maindiv {
  height: calc(100vh - 118px);
  overflow-y: auto;
  overflow-x: hidden;
  margin: -16px -16px 0px -16px;
  padding-bottom: 20px;
}

.maindiv > div {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px;
}

@media (max-width: 576px) {
  .maindiv {
  }
}
</style>